import { render, staticRenderFns } from "./ContentsInsurancePromoDesktopTile.vue?vue&type=template&id=37dfe5e1"
import script from "./ContentsInsurancePromoDesktopTile.vue?vue&type=script&lang=js"
export * from "./ContentsInsurancePromoDesktopTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports